export default __webpack_public_path__ + "static/media/rds_logo_white_1.9672c8f4.png";